import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as ticketActions from './../../../../../actions/ticketAction';
import * as userAction from './../../../../../actions/userAction';
import TicketAssignConfigDetail from './TicketAssignConfigDetail';

const mapStateToProps = state => {
    return {
        ticketState: state.ticketReducer,
        userState: state.userReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTicketAssignConfigDetail: (id) => dispatch(ticketActions.getTicketAssignConfigDetail(id)),
        setTicketAssignConfigDetail: (ticketAssignConfig) => dispatch(ticketActions.setTicketAssignConfigDetail(ticketAssignConfig)),
        
        createTicketAssignConfig: (ticketAssignConfig) => dispatch(ticketActions.createTicketAssignConfig(ticketAssignConfig)),
        updateTicketAssignConfig: (ticketAssignConfig) => dispatch(ticketActions.updateTicketAssignConfig(ticketAssignConfig)),
        
        getCSUsers: (params) => dispatch(userAction.getCSUserAction(params)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TicketAssignConfigDetail));
